<template>
    <div :class="$style.wrapper">
        <Management-StaffList></Management-StaffList>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Management from '../components/Management';

    Vue.component('Management-StaffList', Management.StaffList);
    export default {
        data () {
            return {};
        }
    };
</script>

<style lang="less" module>
    .wrapper {

    }
</style>



// WEBPACK FOOTER //
// src/router/Management.vue